
export type MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType = typeof MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType[keyof typeof MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  FILE: 'FILE',
  LINK: 'LINK',
} as const;
